import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.regexp.split.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestService from "../services/RequestService";
import Notify from 'quasar/src/plugins/Notify.js';;
import { mapState, mapMutations } from "vuex";
import EditStyleComponent from "../components/edit-style-component.vue";
var daysOfWeek = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
export default {
  name: "MainLayout",
  components: {
    EditStyleComponent: EditStyleComponent
  },
  data: function data() {
    return {
      painel: {},
      isLoadingPainel: false,
      requestService: new RequestService(),
      showEditStyle: false,
      clienteId: 0,
      channel: "",
      leftDrawerOpen: true,
      day: null,
      date: null,
      currentTime: null,
      showTitle: false,
      customStyle: "",
      headerStyle: "",
      logo: null,
      voiceVolume: 0,
      showVoiceEnable: false,
      interactionBtn: false
    };
  },
  computed: _objectSpread({}, mapState("vuex_module", ["title", "namePainelDelete", "objectPainel"])),
  methods: _objectSpread(_objectSpread({}, mapMutations("vuex_module", ["setNamePainelDelete"])), {}, {
    getLogo: function getLogo() {
      var _this = this;
      this.requestService.getLogo(this.clienteId).then(function (_ref) {
        var data = _ref.data;
        fetch(data).then(function (res) {
          return res.status === 200 ? _this.logo = data : "";
        });
      }).catch(function (_ref2) {
        var data = _ref2.data;
        _this.createNotify("negative", data.message);
      });
    },
    createNotify: function createNotify(type, message) {
      Notify.create({
        color: type,
        type: type,
        textColor: "white",
        message: message,
        position: "top"
      });
    },
    deleteRequest: function deleteRequest(object) {
      this.setNamePainelDelete(object);
    },
    goToConfigPage: function goToConfigPage() {
      if (clienteId == 0) {
        this.$router.push("/");
      } else {
        this.$router.push("/".concat(this.clienteId, "/paineis"));
      }
    },
    playSoundTest: function playSoundTest() {
      var a = new window.SpeechSynthesisUtterance();
      a.text = "lorem ipsum dolor sit amet consectetur adipiscing elit";
      var voiceList = [];
      a.voice = voiceList[14];
      window.speechSynthesis.speak(a);
    },
    getMidiaConfig: function getMidiaConfig() {
      var _this2 = this;
      this.requestService.getMidiaInfo().then(function (res) {
        _this2.title = res.data.title;
        _this2.volumeVoice = res.data.volume;
      }).catch(function (_ref3) {
        var data = _ref3.data;
        _this2.createNotify("negative", data.message);
      });
    },
    getCurrentDateTime: function getCurrentDateTime() {
      var tempDate = new Date();
      this.day = daysOfWeek[tempDate.getDay()];
      this.currentTime = "".concat(tempDate.getHours().toLocaleString("pt-BR", {
        minimumIntegerDigits: 2,
        useGrouping: false
      }), ":").concat(tempDate.getMinutes().toLocaleString("pt-BR", {
        minimumIntegerDigits: 2,
        useGrouping: false
      }));
      this.date = tempDate.toLocaleString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });
    },
    getPanelByChannel: function getPanelByChannel() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$_this3$request, data, _i, _Object$keys, key;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!(_this3.painel && _this3.painel.configStylesPainel) && !_this3.isLoadingPainel)) {
                _context.next = 17;
                break;
              }
              _context.prev = 1;
              _this3.isLoadingPainel = true;
              _context.next = 5;
              return _this3.requestService.findPanelByChannel(_this3.clienteId, _this3.channel);
            case 5:
              _yield$_this3$request = _context.sent;
              data = _yield$_this3$request.data;
              _this3.painel = data;
              for (_i = 0, _Object$keys = Object.keys(_this3.painel.configStylesPainel); _i < _Object$keys.length; _i++) {
                key = _Object$keys[_i];
                if (_this3.painel.configStylesPainel[key].includes("{")) {
                  _this3.painel.configStylesPainel[key] = JSON.parse(_this3.painel.configStylesPainel[key]);
                }
              }
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              _this3.createNotify("negative", _context.t0.message);
            case 14:
              _context.prev = 14;
              _this3.isLoadingPainel = false;
              return _context.finish(14);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 11, 14, 17]]);
      }))();
    },
    btnInteraction: function btnInteraction() {
      this.interactionBtn = false;
      window.dispatchEvent(new Event("youtube-play-video"));
    }
  }),
  updated: function updated() {
    var currentRoute = this.$route.fullPath;
    if (currentRoute.split("/")[2].toLowerCase() !== "painel") {
      this.interactionBtn = false;
    }
    if (currentRoute.split("/")[2].toLowerCase() !== "paineis" || currentRoute.split("/").length > 3) {
      this.showTitle = true;
      if (currentRoute.split("")[2].toLowerCase() === "cliente") {
        this.customStyle = "config-title-style";
      }
    } else {
      this.showTitle = false;
    }
    if (currentRoute.split("/")[2].toLowerCase() === "config") {
      this.headerStyle = "background-color: #ebebeb; color: black; box-shadow: none;";
      this.showVoiceEnable = false;
    } else {
      this.showVoiceEnable = true;
    }
    this.clienteId = this.$route.params.cliente;
    this.channel = this.$route.params.channel;
    if (this.channel === "" && this.painel.configStylesPainel === undefined) {
      this.getPanelByChannel();
    }
    if (this.$route.fullPath.includes("painel")) {
      this.showEditStyle = true;
    } else {
      this.showEditStyle = false;
      var headerP = document.querySelector(".container-title p");
      var clockHeader = document.querySelectorAll(".clock_container p");
      var timeHeader = document.querySelector(".clock_container #time");
      headerP.setAttribute("style", "");
      clockHeader.forEach(function (e) {
        return e.setAttribute("style", "");
      });
      timeHeader.setAttribute("style", "");
    }
  },
  mounted: function mounted() {
    var _this4 = this;
    this.dayOfWeek = new Date().getDay();
    setInterval(this.getCurrentDateTime, 1000);
    this.getLogo();
    this.$root.$on("updatePainelStyleMainLayout", function () {
      if (_this4.painel.configStylesPainel === undefined) {
        _this4.getPanelByChannel();
      }
    });
    this.$root.$on("updatePainelStyle", function () {
      _this4.getPanelByChannel();
    });
  },
  created: function created() {
    var _this5 = this;
    this.clienteId = this.$route.params.cliente;
    this.channel = this.$route.params.channel;
    if (window.location.pathname.includes("pre-ativado")) {
      this.btnInteraction();
    } else {
      this.$root.$on("btnInteraction", function () {
        var _document$querySelect;
        _this5.interactionBtn = true;
        (_document$querySelect = document.querySelector("#btn-interaction")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.focus();
      });
    }
  }
};